import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Item } from "./Item";
import { useNavigate } from "react-router-dom";

export const UserForm = ({
  inputList,
  cb,
  action_btn,
  user = {},
  onChange = () => {},
  isAdd,
}) => {
  const [userInfo, setUserInfo] = useState(user);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { proxy, auth, lang } = useSelector((s) => s);

  useEffect(() => {
    onChange(userInfo);
  }, [userInfo]);

  const handleAction = () => {
    const error = {};
    let isError = false;

    for (const item of inputList) {
      const {
        key,
        required,
        message: itemMessage,
        label,
        type,
        reference,
      } = item;

      let message = "";

      switch (type) {
        case "option":
          if (required && !userInfo?.[key]?.length) {
            message =
              itemMessage || `Vui lòng chọn ${label.toLocaleLowerCase()}`;
          }
          break;
        default:
          if (required && !userInfo?.[key]?.trim()) {
            message =
              itemMessage || `Vui lòng nhập ${label.toLocaleLowerCase()}`;
          }
          break;
      }
      if (reference && userInfo[key] !== userInfo[reference]) {
        message = `${label} không khớp`;
      }
      if (message) {
        isError = true;
      }
      error[key] = message;
    }

    if (!isError) {
      if (isAdd) {
        navigate("/users/creating?tab=g", {
          state: { userInfo },
        });
      } else {
        cb(userInfo);
      }
    }
    setErrors(error);
  };

  const handleChange = ({ key, value }) => {
    setUserInfo((prev) => ({ ...prev, [key]: value.trim() }));
  };

  return (
    <>
      <div
        className="form_container"
        style={{
          display: "grid",
          justifyItems: "center",
        }}
      >
        {inputList.map(
          ({ label, type = "text", key, isMulti, required, ...props }) => (
            <Item
              label={label}
              type={type}
              value={userInfo?.[key]}
              k={key}
              key={key}
              isMulti={isMulti}
              errorMessage={errors[key]}
              handleChange={handleChange}
              col={7}
              required={required}
              {...props}
            />
          )
        )}
        <div className="col-sm-7 d-flex justify-content-end">
          {isAdd && (
            <button
              className="btn btn-danger"
              onClick={() => {
                navigate("/users");
              }}
            >
              {lang["back"]}
            </button>
          )}
          {action_btn ? (
            <button
              className="btn btn-success btn-custom ml-2"
              onClick={() => {
                handleAction();
              }}
            >
              {action_btn}
            </button>
          ) : null}
        </div>
      </div>
    </>
  );
};
